/**
 * 字段配置的持久化
 */

import { IString } from '../../../../model';
import {
  IAPIProtractedFieldConfig,
  IAutoTableProtractedExtension,
  IConfigField,
  IProtractedFieldConfig,
  ProtractedFeature,
  ProtractedType,
} from '../../model';
import { getProtractedData, setProtractedData } from './protracted';

const isValidate = (
  protractedExtension?: IAutoTableProtractedExtension
): IProtractedFieldConfig | null => {
  if (!protractedExtension) {
    return null;
  }
  const config = protractedExtension[ProtractedFeature.fieldConfig];
  if (!config) {
    return null;
  }
  if (!config.isEnable) {
    return null;
  }
  return config;
};

// 查询持久化数据
export async function getProtractedFieldConfigData<T>(
  callback: (data: ReadonlyArray<T>) => void,
  protractedExtension?: IAutoTableProtractedExtension
) {
  const config = isValidate(protractedExtension);
  if (!config) {
    return callback([]);
  }
  if (config.type === ProtractedType.remote) {
    const data = await getProtractedData<ReadonlyArray<T>>(
      config.guid,
      config.remoteConfig?.getConfig
    );
    const item = data.find((item) => item.key === config.guid);
    if (item) {
      return callback(item.value);
    }
    return callback([]);
  }

  // 本地存储暂不支持
  return callback([]);
}

// 保存持久化数据
export const setProtractedFieldConfigData = async <T>(
  configFields: ReadonlyArray<IConfigField<T>>,
  callback: (status: boolean) => void,
  protractedExtension?: IAutoTableProtractedExtension
) => {
  const config = isValidate(protractedExtension);
  if (!config) {
    return callback(false);
  }
  const data: IAPIProtractedFieldConfig[] = configFields.map((item) => {
    return {
      key: item.key,
      is_shown: item.is_shown !== false,
    };
  });

  if (config.type === ProtractedType.remote) {
    const res = await setProtractedData(
      config.guid,
      data,
      config.remoteConfig?.setConfig
    );
    return callback(res);
  }

  return callback(true);
};

// merge排序
export const protractedDataMergeBySort = <T>(
  protractedData: ReadonlyArray<IAPIProtractedFieldConfig>,
  configFields: ReadonlyArray<IConfigField<T>>
) => {
  if (!protractedData.length) {
    return configFields;
  }

  const oLocal: IString<number> = {};
  protractedData.forEach((item, index) => {
    oLocal[item.key] = index;
  });

  const sortData: IConfigField<T>[] = [];
  const pushData: IConfigField<T>[] = [];
  const len = configFields.length;

  configFields.forEach((item) => {
    // 字段不在本地排序记录中
    const localIndex = oLocal[item.key];
    if (typeof localIndex === 'undefined') {
      pushData.push(item);
      return;
    }

    // 之前所在的排序位置，位于现在字段的长度之外，我们将不会进行排序，以当前原位置插入
    if (len <= localIndex) {
      pushData.push(item);
      return;
    }

    // 如果后端有字段新增删除、这里将会和本地存储的字段不一致，本地储藏将会有风险，这里的容错机制采取加入远程的item
    sortData[localIndex] = Object.assign({}, item, protractedData[localIndex]);
  });

  const res = [...sortData, ...pushData].filter((item) => item);
  return res;
};
